export default __webpack_public_path__ + "static/media/downloadIcon.021ea7a1.svg";